import React from 'react'
import FullName from '../full-name'

const ProfileName = ({ user }) => {
    return (
        <div style={{
            fontSize: '1.3em',
            fontWeight: '600'
        }}>
            <FullName user={user} />
        </div>
    )
}

export default ProfileName